// extracted by mini-css-extract-plugin
export default {"brand-cobalt":"rgb(64, 36, 211)","link":"styles_link__hzAKB","helpIcon":"styles_helpIcon__F8Txp","options":"styles_options__SAXCW"};